export enum Hierarchy {
  ARS = "ars",
  NTS = "nts",
}

export function hierarchyFromNumber(n: 1 | 2) {
  switch (n) {
    case 1:
      return Hierarchy.ARS;

    case 2:
      return Hierarchy.NTS;
  }
}
